var DropDown = require('../../../../common/dropDown/dropDownWr'),
    fvChannel = require('glRadio').channel('FV');


module.exports = DropDown.extend({

    template: require('./addNoteDD.hbs'),

    initialize: function (options ) {

        DropDown.prototype.initialize.call(this, options);

        // ( Both share the notes channel )
        var notesChannel = this.options.channel;

        // Flag to indicate if from notes menu or that created in the header ( whose dropdown menu contents is shared )
        // Can also prevent some dupe processing, like events in the header

        this.isFromViewerHeader = options.isFromViewerHeader;

        this.creatableNoteTypesHelper = notesChannel.request('creatableNoteTypesHelper');

        this.listenTo( notesChannel, 'newNoteMenu:setDisabledMenuItems', this.setDisabilityOfMenuItems );

    },

    /**
     * this.creatableNoteTypesHelper.getPrintedNoteTypes: note type by model constructor.
     * Method transforms the template context to uses the prototypes, appends a note type to them,,
     * and sorts by actionTitle.
     * Template utilizes:
     *  - isDocument
     *  - actionTitle
     *  - iconClass
     *  - noteType
     *  Note:
     *  - this is OLD and evolved and really should be re-written.
     *  - only called for the original created in the notes module.
     */

    templateOptions: function() {

       var notesHash = this.creatableNoteTypesHelper.getPrintedNoteTypes(),
           noteTypes = _.keys(notesHash),
           noteConstrs = _.values(notesHash);

       return {
           noteTypesToCreate: _.chain(noteConstrs)
               .map( function( noteConstr, i) {
                   return _.extend({}, noteConstr.prototype, {
                       noteType: noteTypes[i]
                   });
               }).sortBy(function(n) {
                   return n.actionTitle;
               }).value()
       };

    },

    onRender: function() {

        var notesChannel = this.options.channel;

        if ( !this.isFromViewerHeader ) {

            /* Hook to create the header in the viewer that will share the same DOM as the dropdown content. */
            notesChannel.trigger('notes:newNoteMenuRendered', this.getDDContent());
        }

        // Update disability -- we aren't including in template now or re-rendering ...
        notesChannel.trigger( 'notes:updateNoteTypesToDisable' );

    },

    // TODO: more exact mediation
    onChange: function(value, elData) {

        var lCh = this.options.channel,
            vCh = lCh.request('vChannel'),
            user = fvChannel.request('user'),
            isDocNote = elData.isdoc,
            noteType = elData.noteType;

        /**
         * DVBC-1701 -- trigger an event to set a flag to disable note view mouseenter events prior to changing the active note.
         * The mouse may be over a note view after selection and close of the dropdown so that when closed,
         * the event would be picked up by a 'mouseenter'.  This would cause the shapes of that
         * note view to be made 'active' on the canvas (we only want the shapes of the newly created note to be 'active').
         * ( This may not always happen; it's a race condition between setting the active note -- something that is set here
         * and checked prior to triggering the active shapes. But if the menu closes first, the mousenter can be caught in the DOM
         * before the active note is set ).
         * The dropdown plugin calls onChange (here) prior to onClose, where the menu content is removed causing a mouseover event.
         * Ideally we'd utilize the onClose event to re-enable the capture of mouseenter events, but there are 2 new note menus.
         * When any dropdown is opened, the others are closed and this would re-enable the event capture before a change is made.
         * So we use a hacky timeout afterwards to resume listening for mouseenter events on the note views.
         * Since the user is creating a new note, it's reasonable to expect a certain amount of time to expire.
         * Note: this really only applies to drawable note types.
         */
        lCh.trigger('notes:disableNoteViewHoverEvents');

        setTimeout( function() {
            lCh.trigger('notes:enableNoteViewHoverEvents');
        }, 1500);


        // TODO: this is just a quick fix -- make to disallow the event to go through when doc no pages --
        // the actual menu item is disabled via css override
        if ( vCh.request('activeDocHasNoPages') && !isDocNote )
            return false;

        if ( noteType === 'FLASH_NOTE' && !user.privateGroupsFetched() ) {

            /*
            * Must first get the private groups if they don't exist.
            * TODO: this sets the active note, which will trigger events in pageNotes.
            *  b/f new is actually rendered (eg waiting for flash notes; change this ... why not calling createNewNote ?
            * */

            user.gettingPrivateGroups().done( function(groups) {

                if (groups === null)
                    return;  //error: error handler already set in fetch

                lCh.trigger('notes:changeActiveNote', lCh.request('newNoteModel', isDocNote, noteType), {createNote: true} );

            });

            return;

        }

        lCh.trigger( 'notes:changeActiveNote', lCh.request('newNoteModel', isDocNote, noteType), {createNote: true} );

    },


    // Update disability of menu items and the menu as a whole
    setDisabilityOfMenuItems: function( noteTypesToDisable, allTypesDisabled ) {

        if ( !this.isFromViewerHeader ) {

            var $menuItems = this.getDDContent().find('.mi');
            $menuItems.removeClass('disabled');

            _.each( noteTypesToDisable, function( noteType ) {
                $menuItems.filter('[data-note-type=' + noteType + ']').addClass('disabled');
            });
        }

        // Update for both
        this.$el.toggleClass( 'disabled', allTypesDisabled );

    },

    /**
     * Programatically build up key the events hash to avoid use of constants.
     * While set on both new note menus, key events are only triggered once via Mousetrap
     * Update 3/8: listeners on the note view anyway.
     */
    keyboardEvents: function() {

        if ( this.isFromViewerHeader )
            return null;

        // Note Type Java Enums by Model Constructors -- same used to populate the template
        var notesHash = this.creatableNoteTypesHelper.getPrintedNoteTypes();

        var keyEventsHash = {};

        for (var noteType in notesHash ) {

            var hotKeyOfNoteType = notesHash[noteType].prototype.createHotKey;

            // Utilize an old school closure to prevent all generated functions from
            // using the last note type value in the loop.
            ( function( noteTypeLocal ){

                keyEventsHash[hotKeyOfNoteType] = function(e) {
                    this.mimicOnChangeFromHotKey( e, noteTypeLocal );
                };

            } )(noteType);

        }

        return keyEventsHash;

    },


    /*
     * Hack taking advantage of logic that exists in the DOM.
     * Some day will need to clean this all up -- we'd want a 'can create' for each note type in all scenarios.
     */
    mimicOnChangeFromHotKey: function( e, noteType ) {

        // Prevent any default browser behavior ( eg if went with ctrl keys )
        e.preventDefault();

        // Prevent if a note is already active.
        if ( this.options.channel.request('vChannel').request('activeNote') )
            return false;


        var $mi = this.getDDContent().find( '.mi[data-note-type=' + noteType + ']' );

        // This is superfluous since we are creating the keyEvent functions from
        // the creatable note models type-constructor hash ( as with rendering the template) , but leave in case that ever changes ( they wouldn't be printed ).
        if ($mi.length < 1)
            return false;

        // Return if disabled.
        if ($mi.hasClass('disabled'))
            return false;

        // Mimic this dropdown's onChange by calling it manually.
        // $mi.text isn't  used, but need the data.
        // Triggering a click will not work b/c of the plugin's logic, which looks for the current target of
        // from a click on the dropdown menu.
        this.onChange( $mi.text(), $mi.data() );

    },


    onBeforeDestroy: function() {

        this.stopListening();
        this.off();
        DropDown.prototype.onBeforeDestroy.call(this);


    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/createNew/newNoteMenu.js
 ** module id = 490
 ** module chunks = 0
 **/